import ServiceFactory from "utilities/services/service-factory";
import ShareSpaceManifestRecord from "models/view-models/share-spaces/share-space-manifest-record";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ShareSpaceManifestPathParams {
    guid: string;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint = "sharespaces/recipientaccess/:guid/sharespacemanifest";
const resourceType = ShareSpaceManifestRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const ShareSpaceManifestService = {
    get: ServiceFactory.get<
        ShareSpaceManifestRecord,
        ShareSpaceManifestPathParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default ShareSpaceManifestService;

// #endregion Exports
